export default __webpack_public_path__ + "static/signature-white-b-a590190d4112eb1388a650401d3aa914.png";